<template lang="pug">
  #js-mediaDevice.modal.fade
    .modal-dialog.modal-dialog-centered
      .modal-content
        .modal-header
          h5.modal-title
            | 入力デバイスの切り替え
        .modal-body
          .form-group
            label(for="js-audioSelector")
              | 選択可能なマイク
            .position-relative
              select.form-control.form-control__select.appearance-none.pr-5(
                v-model="audioValue",
                data-media-type="audio",
                @change="updateDevice"
              )
                option(value="")
                  | 選択してください
                option(
                  v-for="device in audioDevices",
                  :value="device.deviceId"
                )
                  | {{ device.label }}
              i.fas.fa-sort.position-absolute.form-control__select-icon
          .form-group.mb-0
            label(for="js-cameraSelector")
              | 選択可能なカメラ
            .position-relative
              select.form-control.form-control__select.appearance-none.pr-5(
                v-model="cameraValue",
                data-media-type="video",
                @change="updateDevice"
              )
                option(value="")
                  | 選択してください
                option(
                  v-for="device in cameraDevices",
                  :value="device.deviceId"
                )
                  | {{ device.label }}
              i.fas.fa-sort.position-absolute.form-control__select-icon
        .modal-footer
          button.btn.btn-action(
            type="button",
            data-dismiss="modal"
          )
            | 閉じる
</template>

<script>
export default {
  name: 'MediaDevice',
  props: [
    'audioDevices', 'cameraDevices'
  ],
  data () {
    return {
      audioValue: '',
      cameraValue: ''
    }
  },
  mounted () {
    this.audioValue = this.$store.state.constraints.audio.deviceId
    this.cameraValue = this.$store.state.constraints.video.deviceId
  },
  methods: {
    async updateDevice (e) {
      // 「選択してください（value=''）」なら何もしない
      const target = e.target
      const value = target.value
      if (value === '') return

      // カメラ or マイクで選択されたdeviceIdを更新
      const constraints = this.$store.state.constraints

      switch (target.dataset.mediaType) {
        case 'audio':
          constraints.audio.deviceId = value
          break
        case 'video':
          constraints.video.deviceId = value
          break
        default:
          break
      }

      const localStream = await navigator.mediaDevices.getUserMedia(constraints)
        .then((stream) => {
          return stream
        })

      // roomへ自身のMediaStreamを再配信
      this.$store.state.room.replaceStream(localStream)

      // localStorageに入れて次回から同じデバイスを使うようにする
      localStorage.setItem('goqmeMedia', JSON.stringify(constraints))

      // storeのconstraints切り替え
      this.$store.dispatch('updateConstraints', { constraints })

      // storeのlocalStream切り替え
      this.$store.dispatch('updateLocalStream', { stream: localStream })
    }
  }
}
</script>
